export const BlogConfig = {
    categories : [
        {
            name : 'Desarrollo web',
            slug : 'desarrollo-web'
        },
        {
            name : 'Desarrollo de aplicaciones',
            slug : 'desarrollo-de-aplicaciones',
            subcategories : [
                {
                    name : 'Aplicaciones móviles',
                    slug: 'aplicaciones-moviles'
                },
                {
                    name : 'Aplicaciones de escritorio',
                    slug: 'aplicaciones-de-escritorio'
                }
            ]
        },
        {
            name : 'Promociones',
            slug : 'promociones'
        }
    ]
}